






























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Course } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';

@Component({
  components: {
    BriocheBackgroundImage,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class ModalCourseMap extends Vue {
  @Prop({ type: Array, required: true })
  private nextSteps!: Course[];
  @Prop({ type: Array, required: true })
  private prerequisites!: Course[];
}
